import { useFormContext } from "react-hook-form";

import { InputTextRow, SelectControllerRow } from "@components";

import { useGeoData } from "@hooks/useGeoData";
import { useLanguage } from "@hooks/useLanguage";

import { getConvertedGeoData } from "@helpers/geoDataConvert";

import { GEO_DATA } from "@constants/geo-data";

import {
  SPOUSE,
  SpouseFormDataType,
} from "@validations/HRM/employee/familyInfoValidation";

const { DISTRICTS } = GEO_DATA;

const SpouseForm = ({ isProfileDisabled }: { isProfileDisabled: boolean }) => {
  const { language } = useLanguage();

  const { data: districts } = useGeoData(DISTRICTS);

  const {
    register,
    formState: { errors },
    control,
    setValue,
  } = useFormContext<SpouseFormDataType>();

  return (
    <div className="d-flex flex-column gap-8">
      <InputTextRow
        label="EMPLOYEE.FAMILY_INFO.FORM.SPOUSE_INFO.SPOUSES_NAME"
        register={{ ...register(SPOUSE.SPOUSE_NAME) }}
        error={errors}
        required
        disabled={isProfileDisabled}
      />
      <SelectControllerRow
        label="EMPLOYEE.FAMILY_INFO.FORM.SPOUSE_INFO.HOME_DISTRICT"
        name={SPOUSE.SPOUSE_HOME_DISTRICT}
        error={errors}
        control={control}
        register={{ ...register(SPOUSE.SPOUSE_HOME_DISTRICT) }}
        options={getConvertedGeoData(districts, language)}
        setValue={setValue}
        isSearchable
        required
        disabled={isProfileDisabled}
      />
      <InputTextRow
        label="EMPLOYEE.FAMILY_INFO.FORM.SPOUSE_INFO.OCCUPATION"
        register={{ ...register(SPOUSE.SPOUSE_OCCUPATION) }}
        error={errors}
        required
        disabled={isProfileDisabled}
      />
      <InputTextRow
        label="EMPLOYEE.FAMILY_INFO.FORM.SPOUSE_INFO.ORGANIZATION"
        register={{ ...register(SPOUSE.SPOUSE_ORGANIZATION) }}
        error={errors}
        disabled={isProfileDisabled}
      />
      <InputTextRow
        label="EMPLOYEE.FAMILY_INFO.FORM.SPOUSE_INFO.DESIGNATION"
        register={{ ...register(SPOUSE.SPOUSE_DESIGNATION) }}
        error={errors}
        disabled={isProfileDisabled}
      />
      <InputTextRow
        label="EMPLOYEE.FAMILY_INFO.FORM.SPOUSE_INFO.LOCATION"
        register={{ ...register(SPOUSE.SPOUSE_LOCATION) }}
        error={errors}
        disabled={isProfileDisabled}
      />
    </div>
  );
};

export default SpouseForm;
